import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import { cancelProjectRemove, removeProject } from '../../modules/projects';

import { projectDeleteFromServer } from '../../modules/user';

import { getUIText } from '../../utils/index';

class ProjectRemoveConfirmDialog extends React.Component {

  state = {
    name: ''
  }

  removeProject() {
    const { project, onProjectRemoveServer, onProjectRemove } = this.props;
    if(project.hasOwnProperty('uuid')) {
      onProjectRemoveServer(project);
    } else {
      onProjectRemove(project.id);
    }
  }

  render() {
    const {
      onCancelProjectRemove,
      project,
      open,
      app,
      translations
    } = this.props;

    return (
      <Dialog onClose={onCancelProjectRemove} open={open}>
        <DialogTitle>{getUIText('DIALOG_PROJECT-REMOVE-TITLE', app.language, translations)} <strong><em>{project.title}</em></strong></DialogTitle>
        <DialogContent>
          <DialogContentText>
            {getUIText('DIALOG_PROJECT-REMOVE-CONTENT-TEXT', app.language, translations)}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onCancelProjectRemove} color="primary">
            {getUIText('GENERAL-CANCEL', app.language, translations)}
          </Button>
          <Button onClick={this.removeProject.bind(this)} color="primary" autoFocus>
            {getUIText('CALCULATION-REMOVE_SECTION', app.language, translations)}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

ProjectRemoveConfirmDialog.propTypes = {
  project: PropTypes.object,
  app: PropTypes.object,
  translations: PropTypes.object,
  onProjectRemoveServer: PropTypes.any,
  onProjectRemove: PropTypes.any,
  onCancelProjectRemove: PropTypes.any,
  open: PropTypes.any,
};

const mapStateToProps = (state) => {
  return {
    project: state.project,
    app: state.app,
    translations: state.translations,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onCancelProjectRemove: index => dispatch(cancelProjectRemove()),
    onProjectRemove: id => dispatch(removeProject({id: id})),
    onProjectRemoveServer: project => {
      dispatch(projectDeleteFromServer({
            project: project,
            failed: cancelProjectRemove
          }
        )
      );
      dispatch(cancelProjectRemove());
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProjectRemoveConfirmDialog);
